const colors = [
  '#1abc9c',
  '#2ecc71',
  '#3498db',
  '#9b59b6',
  '#34495e',
  '#16a085',
  '#27ae60',
  '#2980b9',
  '#8e44ad',
  '#2c3e50',
  '#f1c40f',
  '#e67e22',
  '#e74c3c',
  '#ecf0f1',
  '#95a5a6',
  '#f39c12',
  '#d35400',
  '#c0392b',
  '#bdc3c7',
  '#7f8c8d'
]

const getColor = text => {
  const charCodeSum = text.split('').map(c => c.charCodeAt(0)).reduce((a, b) => a + b, 0)
  const charIndex = charCodeSum - 64
  const colourIndex = charIndex % colors.length

  return colors[colourIndex]
}

const getNameInitials = (name = '', twoLetters = false) => {
  const splittedName = name.toString().toUpperCase().split(' ')

  return twoLetters
    ? splittedName.length > 1
      ? splittedName[0].charAt(0) + splittedName[1].charAt(0)
      : splittedName[0].charAt(0) + splittedName[0].charAt(1)
    : splittedName[0].charAt(0)
}

export const createAvatar = (name, options = {}) => {
  const { size = 60, twoLetter = false, bgColor = null, letterColor = null } = options

  let canvas = document.createElement('canvas')
  const initials = getNameInitials(name, twoLetter)

  canvas.width = size
  canvas.height = size

  const context = canvas.getContext('2d')

  context.fillStyle = bgColor || getColor(name)
  context.fillRect(0, 0, canvas.width, canvas.height)

  context.font = Math.round(canvas.width / 2.5) + 'px Arial'
  context.textAlign = 'center'
  context.fillStyle = letterColor || '#FFF'
  context.fillText(initials, size / 2, size / 1.5)

  const dataURI = canvas.toDataURL()
  canvas = null

  return dataURI
}
